import { Reveal } from "./anim";
import { BRANDS } from "./data";

export const BrandsStrip = () => (
  <section
    data-testid="brands-section"
    className="relative mx-auto max-w-[1400px] px-6 pb-6 pt-2 md:px-10"
  >
    <Reveal>
      <div className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] px-8 py-10 md:px-12">
        <p className="mb-8 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
          <span className="h-px w-8 bg-[hsl(var(--primary))]" /> Brands we&apos;ve built
        </p>
        <div className="flex flex-wrap items-center gap-x-14 gap-y-8">
          {BRANDS.map((b) => (
            <div key={b.name} data-testid={`brand-${b.name.toLowerCase()}`} className="group flex items-baseline gap-3">
              <span className={`text-3xl font-bold text-[hsl(var(--fg))] transition-colors duration-300 group-hover:text-[hsl(var(--primary))] md:text-4xl ${b.cls}`}>
                {b.name}
              </span>
              <span className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted))]">{b.sub}</span>
            </div>
          ))}
          <span className="ml-auto hidden text-sm italic text-[hsl(var(--muted))] md:block">
            + yours next?
          </span>
        </div>
      </div>
    </Reveal>
  </section>
);
